import { render, staticRenderFns } from "./spotinfo.vue?vue&type=template&id=52fe7ee6&scoped=true&"
import script from "./spotinfo.vue?vue&type=script&lang=js&"
export * from "./spotinfo.vue?vue&type=script&lang=js&"
import style0 from "./spotinfo.vue?vue&type=style&index=0&id=52fe7ee6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fe7ee6",
  null
  
)

export default component.exports